import { useTranslate } from 'core/hooks/useTranslate';
import { useState } from 'react';

interface UseDialogOrganizeCourseButtonReturn {
  t: (key: string) => string;
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

export function useDialogOrganizeCourseButton(): UseDialogOrganizeCourseButtonReturn {
  const { t } = useTranslate();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openDialog = (): void => {
    setIsOpen(true);
  };

  const closeDialog = (): void => {
    setIsOpen(false);
  };

  return {
    t,
    isOpen,
    openDialog,
    closeDialog,
  };
}
